module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "iosnode"
  }, [_c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Adams Media")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("An imprint of Simon & Schuster")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("57 Littlefield Street, Avon, MA 02322")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://www.adamsmedia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.adamsmedia.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Copyright © 2017 by Simon and Schuster")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information address Adams Media Subsidiary Rights Department, 1230 Avenue of the Americas, New York, NY 10020.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("ADAMS MEDIA and colophon are trademarks of Simon and Schuster.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Contains material adapted from "), _c('em', {}, [_vm._v("The Everything"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("®")]), _vm._v(" Tarot Book, 2nd Edition")]), _vm._v(" by Skye Alexander, copyright © 2006 by Simon & Schuster, Inc., ISBN 10: 1-59337-656-1, ISBN 13: 978-1-59337-656-7.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Illustrations from the Rider-Waite Tarot Deck® reproduced by permission of U.S. Games Systems, Inc., Stamford, CT 06902 USA. Copyright © 1971 by U.S. Games Systems, Inc. Further reproduction prohibited. The Universal Waite Tarot Deck® is a registered trademark of U.S. Games Systems, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Cover design by Stephanie Hannus.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover and interior images © 123RF/Daria Solomennikova.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("For information about special discounts for bulk purchases, please contact Simon & Schuster Special Sales at 1-866-506-1949 or "), _c('span', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "mailto:business@simonandschuster.com"
    }
  }, [_vm._v("business@simonandschuster.com")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("The Simon & Schuster Speakers Bureau can bring authors to your live event. For more information or to book an event contact the Simon & Schuster Speakers Bureau at 1-866-248-3049 or visit our website at "), _c('span', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://www.simonspeakers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonspeakers.com")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("How to read tarot.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Avon, Massachusetts: Adams Media, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("LCCN 2016042025 | ISBN 9781507201879 (pb) | ISBN 1507201877 (pb) | ISBN 9781507201886 (ebook) | ISBN 1507201885 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("LCSH: Tarot.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("LCC BF1879.T2 H68 2017 | DDC 133.3/2424--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("LC record available at "), _c('span', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://lccn.loc.gov/2016042025",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2016042025")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("ISBN 10: 1-5072-0187-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 13: 978-1-5072-0187-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eISBN 10: 1-5072-0188-5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eISBN 13: 978-1-5072-0188-6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-sa"
  }, [_vm._v("Many of the designations used by manufacturers and sellers to distinguish their products are claimed as trademarks. Where those designations appear in this book and Simon & Schuster, Inc., was aware of a trademark claim, the designations have been printed with initial capital letters.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb65a4e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/N157756.vue
// module id = 66
// module chunks = 0